export default {
    advantagesLinkTitle: 'Fordelsprogram',
};
